import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-500 via-purple-400 to-pink-400 py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-pink-300 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-400 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-8">
            <Icon name="HeartIcon" size={24} className="text-white" variant="solid" />
            <span className="text-white font-cta font-bold text-sm">
              Direct Impact • Transparent Giving • Real Change
            </span>
          </div>
          
          <h1 className="text-5xl lg:text-6xl font-headline font-bold text-white mb-6 leading-tight drop-shadow-lg">
            Transform Lives Through
            <span className="block mt-2 drop-shadow-lg">Compassionate Action</span>
          </h1>
          
          <p className="text-xl text-white mb-8 leading-relaxed font-body drop-shadow-md">
            Join a global movement of compassion. Every contribution directly supports vulnerable communities worldwide.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link href="/donate" className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg font-cta font-bold text-lg transition-all duration-300 hover:bg-white/30 hover:scale-105 hover:shadow-lg pulse-gentle flex items-center space-x-2">
              <Icon name="HandRaisedIcon" size={24} variant="solid" />
              <span>Start Giving Today</span>
            </Link>
            <button className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg font-cta font-bold text-lg transition-all duration-300 hover:bg-white/20 flex items-center space-x-2">
              <Icon name="PlayIcon" size={24} variant="solid" />
              <span>Watch Impact Stories</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;